<template>
  <div>
    <br>
    <el-form ref="editForm" :rules="rules" :model="editForm" label-width="90px">
      <el-form-item label="First Name" prop="firstName">
        <el-input v-model="editForm.FirstName"></el-input>
      </el-form-item>
      <el-form-item label="Last Name" prop="lastName">
        <el-input v-model="editForm.LastName"></el-input>
      </el-form-item>
      <el-form-item label="Emails">
        <el-input
          v-for="(email, i) in editForm.EmailAddresses"
          :key="`e-${i}`"
          v-model="editForm.EmailAddresses[i].Email"
        ></el-input>
      </el-form-item>
      <el-form-item label="Phone #'s">
        <el-input
          v-for="(phone, i) in editForm.PhoneNumbers"
          :key="`p-${i}`"
          v-model="editForm.PhoneNumbers[i].Number"
        ></el-input>
      </el-form-item>
      <el-form-item label="Address" v-for="(address, i) in editForm.Addresses" :key="`a-${i}`">
        <el-input v-model="editForm.Addresses[i].Address"></el-input>
      </el-form-item>
      <el-button round size="small" @click="$emit('cancel')">Cancel</el-button>
      <el-button round size="small" @click="$emit('save', editForm)">Save</el-button>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ['form'],
  data() {
    return {
      editForm: null,
      rules: {
        firstName: [
          {
            required: true,
            message: 'Please input first name',
            trigger: 'change'
          }
        ],
        lastName: [
          {
            required: true,
            message: 'Please input last name',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    setContactForm(contact) {
      if (!contact) return
      this.editForm = Object.assign({}, contact)
    }
  },
  watch: {
    form: {
      handler: 'setContactForm',
      immediate: true
    }
  }
}
</script>

